<template>
    <div>
        <div style="background:#fff">
            <div style="width: 1200px;margin: 20px auto 0 auto;">
                <div class="title">{{ locale=='en'? bidSection.sectionNameEn:locale=='lo'?bidSection.sectionNameLo:bidSection.sectionName }}</div>
                <!-- 基本信息 -->
                <div class="box">
                    <div class="text">{{ $t('view.基本信息') }}</div>
                    <el-table :cell-style='rowClass' :show-header="false"  :span-method="objectSpanMethod"  :data="tableData" border style="margin: 20px 0; width:100%">
                        <el-table-column align="center" width="150" prop="LeftTitle">
                            <template slot-scope="scope">
                                {{ scope.row.LeftTitle?scope.row.LeftTitle:'/' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="LeftValue"></el-table-column>
                        <el-table-column align="center" width="150" prop="RightTitle">
                             <template slot-scope="scope">
                                {{ scope.row.RightTitle?scope.row.RightTitle:'/' }}
                            </template>
                        </el-table-column>
                      <el-table-column prop="RightValue">
                        <template slot-scope="scope">
                          <span v-if="scope.row.RightValue!=$t('view.是否提交投标文件')">{{scope.row.RightValue?scope.row.RightValue:'/'}}</span>
                          <span v-else-if="bidSection.isCommitBusinessFile!=1 &&bidSection.isCommitTechnicalFile!=1">{{ $t('view.否') }}</span>
                          <span v-else>
                                <el-checkbox true-label="1" false-label="0" v-model="bidSection.isCommitBusinessFile" disabled>{{ $t('view.商务文件') }}</el-checkbox>
                                <el-checkbox true-label="1" false-label="0" v-model="bidSection.isCommitTechnicalFile" disabled>{{ $t('view.技术文件') }}</el-checkbox>
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                </div>
                <!-- 支付比例 -->
                 <div class="box"  v-if="bidSectors.length&&bidSection.settleMethod==2">
                    <div class="text" style="margin-bottom:20px">{{$t('view.支付比例')}}</div>
                    <div style="display: flex;width: 100%;margin-bottom: 20px;">
                        <div v-if="item.type" style="text-align: center;flex: 1;border: solid 1px #F5F7FA;" v-for="item in settleMethodsList" :key="item.type">
                            <div style="background:#F2F6FC;line-height: 40px;line-height: 40px;" >{{ locale=='en'? item.typeEn:locale=='lo'?item.typeLo:item.type }}</div>
                            <div  style="margin: 10px 0;font-size: 14px">{{ item.percentage }}%</div>
                        </div>
                    </div>
                </div>
                <!-- 本轮报价 -->
                <div class="box">
                    <div style="display: flex;justify-content: space-between;align-items: flex-end;">
                        <span  class="text" >{{ $t('view.本轮报价') }}</span>
                        <sapn v-if="bidSection.budgetType==1&&bidSection.isYuanJu!=1" style="color: #0637F9;font-size: 18px;font-weight: bold;">{{ $t('view.项目总预算：') }}{{getStatus('sys_currency',bidSection.currencyTypeId?bidSection.currencyTypeId:bidSection.currency,'remark')}}{{formatNum(bidSection.projectPrice)}}{{moneyUnit}}</sapn>
                    </div>
                    <div style="display:flex;justify-content: space-between;margin:10px 0">
                        <div style="display: flex;align-items: center;">
                            <el-button type="warning" plain size="mini" @click="handleExport">{{ $t('view.下载模板') }}</el-button>
                            <el-upload :span="1.5" :show-file-list="false" :action="uploadFile"  :http-request="importFile"  accept=".xlsx" style="margin-left:10px">
                                <el-button type="primary" size="mini">{{ $t('view.导入') }}</el-button>
                            </el-upload>
                            <div style="margin-left:20px;font-size:14px" v-if="timeList">{{ $t('view.距离报价结束：') }}
                                <span style="color: #B80008;">{{ timeList }}</span>
                            </div>
                            <div style="margin-left:20px;font-size:14px;color: #B80008;">
                                当日报价时间段：
                                <span>{{ bidSection.quotesStart }}-{{  bidSection.quotesEnd }}</span>
                            </div>  
                        </div>
                        <span style="color: #B80008;">
                            <span v-if="HistoricalQuotation&&HistoricalQuotation.length&&bidSection.showRanking&& bidSection.rankingType==1">{{ $t('view.整体排名：当前排名第') }}{{ details.totalPriceRanking }}</span>
                            <span v-if="bidSection.rankingType==1&&bidSection.supplierOffer==1" style="margin-left: 20px;">{{ bidSection.biddingTradeType==1?$t('view.当前最低价'): $t('view.当前最高价') }}：
                                {{getStatus('sys_currency',bidSection.currencyTypeId?bidSection.currencyTypeId:bidSection.currency,'remark')  }}{{ formatNum(bidSection.minOrMaxQuotesAmount) }}<span>{{ moneyUnit }}</span></span>
                        </span>
                    </div>
                    <!-- 销售 --> 
                    <span style="color:#999" v-if="bidSectors.length&&bidSection.isLowest==1&&bidSection.biddingTradeType==2">
                        {{ bidSection.isAllLowest==1?$t('view.每轮次报价上涨幅度比全场最高价高'):$t('view.每轮次报价上涨幅度比上一轮报价高') }}
                        <span style="color: #B80008;padding: 0 2px;">{{bidSectors[0].sectorCutpriceType==1?bidSection.priceRange:formatNum(bidSection.priceRange)  }}</span>{{ bidSectors[0].sectorCutpriceType==1?'%':$t('view.元') }}
                    </span>
                    <!-- 采购 -->
                    <span style="color:#999" v-if="bidSectors.length&&bidSection.isLowest==1&&bidSection.biddingTradeType==1">
                        {{bidSection.isAllLowest==1? $t('view.每轮次报价降价幅度比全场最低价低'):$t('view.每轮次报价降价幅度比上一轮报价低') }}
                        <span style="color: #B80008;padding: 0 2px;">{{ bidSectors[0].sectorCutpriceType==1?bidSection.priceRange:formatNum(bidSection.priceRange) }}</span>{{ bidSectors[0].sectorCutpriceType==1?'%':$t('view.元') }}
                    </span>
                    <!-- engineeringType 总包 2 1是正常的 -->
                    <div v-show="bidSection.sectionType != '1'&&bidSection.engineeringType!=2">
                        <el-table max-height="500"  border header-row-class-name="tableHeader"  :data="bidSectors" style="width: 100%;margin-top: 15px;">
                                <el-table-column align="center" fixed type="index" width="60" :label="$t('view.序号')"/>
                                <el-table-column fixed header-align="center" width="300" :label="$t('view.标的物信息')">
                                    <template slot-scope="scope">
                                        <div class="twoLine" style="max-height: 50px;"><span style="color: #9FA6AC;">{{$t('view.物料名称')}}：</span> {{ locale=='en'? scope.row.nameEn:locale=='lo'?scope.row.nameLo:scope.row.name }}</div>
                                        <div v-if="bidSection.budgetType==2&&bidSection.isYuanJu!=1">
                                            <span style="color: #9FA6AC;">{{ bidSection.sectorBudgetType==1? $t('view.预算总价'):$t('view.预算单价')}}：</span>
                                            {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{ formatNum(scope.row.budgetAmount) }}{{ moneyUnit }}
                                        </div>
                                        <div v-if="bidSection.isYuanJu==1"><span style="color: #9FA6AC;">{{$t('view.预算金额')}}：</span>
                                            {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{formatNum(bidSection.biddingTradeType==1?scope.row.maxPrice :scope.row.minPrice ) }}{{ moneyUnit }}
                                        </div>
                                        <div><span style="color: #9FA6AC;">{{$t('view.需求数量')}}：</span> {{ scope.row.number }} / {{ locale=='en'? scope.row.sectorUnitsEn:locale=='lo'?scope.row.sectorUnitsLo:scope.row.sectorUnits }}</div>
                                        <div><span style="color: #9FA6AC;">{{$t('view.规格')}}：</span> {{ locale == 'en' ? scope.row.specificationsEn : locale == 'lo' ? scope.row.specificationsLo:scope.row.specifications}}</div>
                                        <div><span style="color: #9FA6AC;">{{$t('view.型号')}}：</span> {{ locale == 'en' ? scope.row.modelEn : locale == 'lo' ? scope.row.modelLo : scope.row.model }}</div>
                                        <div class="single-line" :title="scope.row.remark" ><span style="color: #9FA6AC;">{{$t('view.其他')}}：</span>{{scope.row.remark?scope.row.remark:'-' }}</div>
                                        <div class="single-line" v-if="scope.row.outFileList&&scope.row.outFileList.length"><span style="color: #9FA6AC;">{{$t('view.技术附件')}}：<span @click="handleViewFile(scope.row.outFileList[0].filePath,scope.row.outFileList[0].fileName)" style="cursor: pointer;">{{scope.row.outFileList[0].fileName }}</span></span></div>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" v-if="bidSection.showRanking&& bidSection.rankingType==0" width="100" :label="$t('view.排名')">
                                        <template  slot-scope="scope">
                                            <span class="mainColor">{{ scope.row.priceRanking }}</span>
                                        </template>
                                </el-table-column>
                                <el-table-column align="center" v-if="bidSection.rankingType==0&&bidSection.supplierOffer==1" prop="remarks" width="150" :label="bidSection.biddingTradeType==1?$t('view.当前最低价'): $t('view.当前最高价')">
                                    <template  slot-scope="scope">
                                        <span class="mainColor">{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{ formatNum(scope.row.minOrMaxQuotesAmount)  }}</span>
                                    </template>
                                </el-table-column>
                                <!-- 煤炭的要显示 -->
                                <el-table-column v-if="bidSection.projectMaterialType==35" align="center"  prop="priceType" key="priceType" width="150" :label="$t('view.价格类型')">
                                </el-table-column>
                                <el-table-column v-if="bidSection.quotationMethod!=1" align="center" prop="sectorPrice" :label="(bidSection.isTax=='1'? $t('view.含税单价'):$t('view.单价')) +'('+moneyUnit+')'" width="200">
                                    <template slot-scope="scope">
                                            <el-input size="mini" class="BlueEditable" maxlength="33" :placeholder="$t('view.请输入')" style="width: 90%;" v-model="scope.row.sectorPrice" ></el-input>
                                            <div style="font-size: 14px;color: #626783;line-height: 30px;" v-if="CbidSectors[scope.$index].sectorPrice">{{ $t('view.上一轮') }} 
                                                {{getStatus('sys_currency',bidSection.currencyTypeId?bidSection.currencyTypeId:bidSection.currency,'remark')}}{{ formatNum(CbidSectors[scope.$index].sectorPrice) }}{{ moneyUnit }}</div>
                                        </template>
                                    </el-table-column> 
                                <el-table-column v-if="bidSection.isTax=='1'" align="center" prop="taxRate" :label="$t('view.税率')" width="150">
                                    <template slot-scope="scope">
                                        <el-select class="BlueEditable" size="mini" style="width: 90%" clearable v-model="scope.row.taxRate">
                                            <el-option v-for="item in sys_tax_rate" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="bidSection.projectMaterialType!=35" align="center" prop="totalPrice" width="200" :label="$t('view.总价')+'('+moneyUnit+')'">
                                    <template slot-scope="scope">
                                        <el-input class="BlueEditable" style="width:90%" v-if="bidSection.quotationMethod==1" size="mini" :placeholder="$t('view.请输入')"  v-model="scope.row.totalPrice" maxlength="33"></el-input>
                                        <span v-else>
                                            {{getStatus('sys_currency',bidSection.currencyTypeId?bidSection.currencyTypeId:bidSection.currency,'remark')}}{{ formatNum(((Math.round((scope.row.otherExpenses||0)*10000)  + Math.round((scope.row.sectorPrice ? scope.row.sectorPrice : (CbidSectors[scope.$index].sectorPrice||0))*10000) * (scope.row.number||0)) / 10000).toFixed(4))}}
                                        </span>
                                        <div style="font-size: 14px;color: #626783;line-height: 30px;" v-if="CbidSectors[scope.$index].totalPrice">{{ $t('view.上一轮') }}
                                             {{getStatus('sys_currency',bidSection.currencyTypeId?bidSection.currencyTypeId:bidSection.currency,'remark')}}{{ formatNum(CbidSectors[scope.$index].totalPrice) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="bidSection.successfulBidderMethod==1" align="center" prop="settleMethod" width="150" :label="$t('view.结算方式')">
                                    <template slot-scope="scope">
                                        <span v-if="bidSection.settleMethod||scope.row.isForceSettleMethod==1">{{getStatus('sys_settle_method',scope.row.settleMethod)  }}</span>
                                        <el-select class="BlueEditable" v-else size="mini" style="width: 90%" clearable v-model="scope.row.settleMethod">
                                            <el-option v-for="item in sys_settle_method" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" prop="settleMethod" :label="$t('view.报价说明')" width="550">
                                    <template slot-scope="scope">
                                        <vue-editor  v-model="scope.row.remarks" class="my-custom-editor BlueEditable" style="width: 520px" :disabled="scope.row.isForceSettleMethod==1"></vue-editor>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" prop="settleMethod" :label="$t('view.备注')" width="200">
                                    <template slot-scope="scope">
                                        <el-input class="BlueEditable" type="textarea" :placeholder="$t('view.请输入')"  resize='none' :rows="3" size="mini"  v-model="scope.row.remarks1" ></el-input>
                                    </template>
                                </el-table-column>
                               
                        </el-table>
                        <el-form :model="form"  label-width="120px" style="margin-top:10px">
                            <el-form-item v-if="bidSection.successfulBidderMethod!=1" :label="$t('view.结算方式')" prop="settleMethod">
                                <span v-if="bidSection.settleMethod||form.isForceSettleMethod==1">{{getStatus('sys_settle_method',form.settleMethod)  }}</span>
                                <el-select class="BlueEditable" v-else size="mini" style="width: 300px" clearable v-model="form.settleMethod">
                                    <el-option v-for="item in sys_settle_method" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('view.报价说明')" prop="declareName">
                                <vue-editor  v-model="form.remarks" class="my-custom-editor BlueEditable" style="width: 520px" :disabled="form.isForceSettleMethod==1"></vue-editor>
                            </el-form-item>
                            <el-form-item :label="$t('view.备注')" prop="declareName" >
                                <el-input class="BlueEditable" type="textarea" :placeholder="$t('view.请输入')"  resize='none' :rows="3" size="mini" style="width: 520px;" v-model="form.remarks1" ></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('view.附件')" prop="declareName">
                                <el-upload  :action="uploadFile"  v-if="!form.fileList||( form.fileList&& form.fileList.length<1)"
                                    :disabled="details.disabled" :headers="headers"
                                    :file-list="form.fileList"
                                    :show-file-list="false"
                                    :on-success="(res,file)=>{successList( form.fileList,res,file)}"
                                    :on-remove="(res,file)=>{handleRemoveClear(form,res)}">
                                    <el-button  size="mini" style="background: #409EFF;border-color:#409EFF;" type="primary">上传文件</el-button>
                                </el-upload>    
                                <div class="clickText" v-for="(item,index) in form.fileList" :key="index">
                                    <span style="line-height: 20px;font-size: 14px;color:#409EFF" @click.stop="handleViewFile(item.filePath, item.fileName)">{{ item.fileName }}</span>
                                    <span style="margin-left:10px;" @click="form.fileList.splice(index, 1);">x</span>
                                </div>
                            </el-form-item>
                        </el-form> 
                    </div>

                    <!-- 总包 -->
                    <el-table max-height="500" v-show="bidSection.engineeringType==2" border header-row-class-name="tableHeader" :data="bidSectors" style="width: 100%;margin-top: 15px;">
                        <el-table-column type="expand">
                            <template slot-scope="props"> 
                                <el-table :data="props.row.details" border header-row-class-name="tableHeader" style="width: 100%">
                                    <el-table-column align="center"   :label="$t('view.物资名称')">
                                        <template slot-scope="scope">
                                            <div>{{ ++scope.$index }}、{{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}</div>
                                            <div>{{ $t('view.数量') }}：{{ scope.row.number }}{{ scope.row.detailUnits }}</div> 
                                            <div>{{$t('view.报价方式')}}：{{scope.row.quotationMethod==1?$t('view.总价'):$t('view.单价')}}（{{scope.row.detailUnits}}）</div>
                                            <div class="mainColor" v-if="scope.row.budgetAmount&&bidSection.budgetType==2">【{{$t('view.限价')}}：{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{formatNum(scope.row.budgetAmount)}}（{{scope.row.moneyUnit}}/{{scope.row.detailUnits}}）】</div>
                                        </template>
                                    </el-table-column>
                                      <!-- 排名 -->
                                    <el-table-column align="center" v-if="bidSection.showRanking&& bidSection.rankingType==0" width="100" :label="$t('view.排名')">
                                        <template  slot-scope="scope">
                                            <span class="mainColor">{{ scope.row.priceRanking }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column align="center" v-if="bidSection.rankingType==0&&bidSection.supplierOffer==1" prop="remarks" width="150" :label="bidSection.biddingTradeType==1?$t('view.当前最低价'): $t('view.当前最高价')">
                                        <template  slot-scope="scope">
                                            <span class="mainColor">{{getStatus('sys_currency',bidSection.currencyTypeId?bidSection.currencyTypeId:bidSection.currency,'remark')  }}{{formatNum(scope.row.minOrMaxQuotesAmount)   }}</span>
                                        </template>
                                    </el-table-column>
                                     <!-- 煤炭的要显示 -->
                                    <el-table-column v-if="bidSection.projectMaterialType==35" align="center"  prop="priceType" key="priceType" width="150" :label="$t('view.价格类型')">
                                    </el-table-column>
                                    <el-table-column align="center"  :label="bidSection.isTax=='1'? $t('view.报价（含税）'):$t('view.报价')">
                                        <template slot-scope="scope">
                                            <el-input class="BlueEditable"  style="width:90%"  size="mini" :placeholder="$t('view.请输入')"  v-model="scope.row.detailPrice"  maxlength="33"></el-input>
                                            <div style="font-size: 14px;color: #626783;line-height: 30px;" v-if="CbidSectors[props.$index].details[scope.$index].detailPrice">{{ $t('view.上一轮') }} 
                                                {{getStatus('sys_currency',bidSection.currencyTypeId?bidSection.currencyTypeId:bidSection.currency,'remark')}}{{formatNum(CbidSectors[props.$index].details[scope.$index].detailPrice ) }}</div>
                                        </template>
                                    </el-table-column>
                                    <!-- 税率 -->
                                    <el-table-column v-if="bidSection.isTax=='1'" align="center" :label="$t('view.税率')">
                                        <template slot-scope="scope">
                                            <el-select class="BlueEditable" size="mini" style="width: 90%" clearable v-model="scope.row.taxRate">
                                                <el-option v-for="item in sys_tax_rate" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <!-- 系数 -->
                                    <el-table-column align="center"   :label="$t('view.系数')">
                                        <template slot-scope="scope">
                                            <div v-if="scope.row.coefficientName">
                                                <span>{{ scope.row.coefficientName }}</span> 
                                                <el-input size="mini" class="BlueEditable" maxlength="33" :placeholder="$t('view.请输入')" style="width: 90%;" v-model="scope.row.coefficient" ></el-input>
                                            </div>
                                            <div v-else>/</div>
                                            <div style="font-size: 14px;color: #626783;line-height: 30px;" v-if="CbidSectors[props.$index].details[scope.$index].coefficient">{{ $t('view.上一轮') }}
                                          {{ CbidSectors[props.$index].details[scope.$index].coefficient }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column align="center" v-if="bidSection.projectMaterialType!=35" :label="bidSection.isTax=='1'? $t('view.总价（含税）') :$t('view.总价')">
                                        <template slot-scope="scope">
                                            <!-- 总价 -->
                                            <span v-if="scope.row.quotationMethod==1" > {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')}}{{formatNum(scope.row.detailPrice?(scope.row.detailPrice*1).toFixed(4):(CbidSectors[props.$index].details[scope.$index].detailPrice*1).toFixed(4)) }}</span>
                                            <!-- 单价 -->
                                            <span v-else>{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')}}{{ formatNum(((scope.row.detailPrice?scope.row.detailPrice:CbidSectors[props.$index].details[scope.$index].detailPrice)* scope.row.number).toFixed(4))}}</span>
                                        </template> 
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-table-column>
                        <el-table-column  align="center" :label="$t('view.标段信息')">
                            <template slot-scope="scope">
                                <div>{{ $t('view.标段') }} {{scope.row.sort}}：{{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}</div>
                                <div  class="mainColor">（{{getStatus('sys_currency',scope.row.currency)  }}/{{scope.row.moneyUnit}}）</div>
                            </template>
                        </el-table-column>
                        <!-- 排名 -->
                        <el-table-column align="center" v-if="bidSection.showRanking&& bidSection.rankingType==0" width="100" :label="$t('view.排名')">
                                <template  slot-scope="scope">
                                    <span class="mainColor">{{ scope.row.priceRanking }}</span>
                                </template>
                        </el-table-column>
                        <el-table-column align="center" v-if="bidSection.rankingType==0&&bidSection.supplierOffer==1" prop="remarks" width="150" :label="bidSection.biddingTradeType==1?$t('view.当前最低价'): $t('view.当前最高价')">
                            <template  slot-scope="scope">
                                <span class="mainColor">{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{ formatNum(scope.row.minOrMaxQuotesAmount)  }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="150" prop="totalPrice" :label="bidSection.isTax=='1'? $t('view.总价（含税）') :$t('view.总价')">
                            <template  slot-scope="scope">
                                <span class="mainColor">{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')}}{{ formatNum(scope.row.totalPrice) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" :label="$t('view.备注')">
                            <template  slot-scope="scope">
                                <el-input class="BlueEditable" style="width:90%" type="textarea" resize='none' :placeholder="$t('view.请输入')"  :rows="2"  size="mini"  v-model="scope.row.remarks1" ></el-input>
                            </template>
                        </el-table-column>
                    </el-table>


                    <el-table max-height="500" v-show="bidSection.sectionType==1" :data="bidSectors" stripe   header-row-class-name="tableHeader" style="width: 100%">
                        <el-table-column type="expand" fixed >
                            <template slot-scope="props">
                                <el-table :data="props.row.details" border header-row-class-name="tableHeader" style="width: 100%">
                                    <el-table-column align="center" show-overflow-tooltip type="index" width="60" :label="$t('view.序号')"/>
                                    <el-table-column align="center" show-overflow-tooltip prop="sectorName" :label="$t('view.物资名称')"></el-table-column>
                                    
                                    <el-table-column align="center" show-overflow-tooltip prop="remark" :label="$t('view.规格')">
                                        <template slot-scope="scope">
                                            {{ locale == 'en' ? scope.row.specificationsEn : locale == 'lo' ? scope.row.specificationsLo:scope.row.specifications}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column align="center" show-overflow-tooltip prop="remark" :label="$t('view.型号')">
                                        <template slot-scope="scope">
                                            {{ locale == 'en' ? scope.row.modelEn : locale == 'lo' ? scope.row.modelLo : scope.row.model }}
                                        </template>
                                    </el-table-column>
                                            
                                    <el-table-column align="center" show-overflow-tooltip prop="sectorNumber" :label="$t('view.需求数量')"></el-table-column>
                                    <el-table-column align="center" show-overflow-tooltip  :label="$t('view.计量单位')">
                                        <template slot-scope="scope">
                                            {{ locale == 'en' ? scope.row.detailUnitsEn : locale == 'lo' ? scope.row.detailUnitsLo:scope.row.detailUnits}}
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column v-if="bidSection.budgetType==2" key="budgetAmount" align="center" show-overflow-tooltip prop="budgetAmount" :label="bidSection.sectorBudgetType==1? $t('view.预算总价'):$t('view.预算单价')">
                                        <template slot-scope="scope">
                                            {{scope.row.budgetAmount}}{{moneyUnit}}
                                        </template>
                                    </el-table-column> -->
                                </el-table>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" fixed :label="$t('view.标段名称')" width="260" >
                            <template slot-scope="scope">
                                <div>{{ locale=='en'? scope.row.nameEn:locale=='lo'?scope.row.nameLo:scope.row.name }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" v-if="bidSection.showRanking&& bidSection.rankingType==0" width="100" :label="$t('view.排名')">
                                <template  slot-scope="scope">
                                    <span class="mainColor">{{ scope.row.priceRanking }}</span>
                                </template>
                        </el-table-column>
                        <el-table-column align="center" v-if="bidSection.supplierOffer==1" prop="remarks" width="150" :label="$t('view.本轮最低价')">
                                <template  slot-scope="scope">
                                    <span class="mainColor">{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{ formatNum(scope.row.minOrMaxQuotesAmount)  }}</span>
                                </template>
                        </el-table-column>
                        <el-table-column  v-if="bidSection.quotationMethod!=1" align="center" prop="sectorPrice" :label="(bidSection.isTax=='1'? $t('view.含税单价'):$t('view.单价')) +'('+moneyUnit+')'" width="150">
                            <template slot-scope="scope">
                                <el-input size="mini"
                                class="BlueEditable"
                                 maxlength="33"
                                 :placeholder="$t('view.请输入')" style="width: 90%;" v-model="scope.row.sectorPrice" ></el-input>
                                <div style="font-size: 14px;color: #626783;line-height: 30px;" v-if="CbidSectors[scope.$index].sectorPrice">{{ $t('view.上一轮') }}
                                     {{getStatus('sys_currency',bidSection.currencyTypeId?bidSection.currencyTypeId:bidSection.currency,'remark')}}{{ formatNum(CbidSectors[scope.$index].sectorPrice) }}{{ moneyUnit }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="bidSection.isTax=='1'" align="center" prop="taxRate" :label="$t('view.税率')" width="150">
                            <template slot-scope="scope">
                                 <el-select size="mini" class="BlueEditable" style="width: 90%" clearable v-model="scope.row.taxRate">
                                    <el-option v-for="item in sys_tax_rate" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column v-if="bidSection.quotationMethod!=1" align="center" prop="totalMaterialPrice" width="150" :label="$t('view.物料总价')+'('+moneyUnit+')'">
                            <template slot-scope="scope">
                                {{ ( Math.floor(scope.row.sectorPrice*10000)/10000*scope.row.number).toFixed(4) }}
                            </template>
                        </el-table-column> -->
                        <!-- <el-table-column v-if="bidSection.quotationMethod!=1&& bidSection.isYuanJu!=1" align="center" prop="otherExpenses" width="120" :label="$t('view.其他费用')+'('+moneyUnit+')'">
                            <template slot-scope="scope">
                                <el-input size="mini" v-model="scope.row.otherExpenses"
                                 maxlength="33"
                                style="width: 70px;"></el-input>
                            </template>
                        </el-table-column> -->
                        <el-table-column v-if="bidSection.projectMaterialType!=35" align="center" prop="totalPrice" width="150" :label="$t('view.总价')+'('+moneyUnit+')'">
                            <template slot-scope="scope">
                                <div v-if="bidSection.quotationMethod==1">{{scope.row.priceType}}</div>
                                <el-input  class="BlueEditable" v-if="bidSection.quotationMethod==1" size="mini" :placeholder="$t('view.请输入')" v-model="scope.row.totalPrice" maxlength="33" style="width: 90%"></el-input>
                                <span v-else>
                                    {{getStatus('sys_currency',bidSection.currencyTypeId?bidSection.currencyTypeId:bidSection.currency,'remark')}}{{ formatNum(((Math.round((scope.row.otherExpenses||0)*10000)  + Math.round((scope.row.sectorPrice||0)*10000)*(scope.row.number||0))/10000).toFixed(4))}}
                                </span>
                                <div style="font-size: 14px;color: #626783;line-height: 30px;" v-if="CbidSectors[scope.$index].totalPrice">{{ $t('view.上一轮') }}
                                     {{getStatus('sys_currency',bidSection.currencyTypeId?bidSection.currencyTypeId:bidSection.currency,'remark')}}{{ formatNum(CbidSectors[scope.$index].totalPrice )}}</div>
                            </template>
                        </el-table-column>
                        
                        <el-table-column  align="center" prop="settleMethod" width="150" :label="$t('view.结算方式')">
                            <template slot-scope="scope">
                                <span v-if="(!scope.row.settleMethod)&&scope.row.settleMethod!=0">无</span>
                                <span v-if="details.acceptPaymentMethods==1">
                                    {{getStatus('sys_settle_method',scope.row.settleMethod)}}
                                </span>
                                <el-select v-else class="BlueEditable" size="mini" style="width: 90%" clearable v-model="scope.row.settleMethod">
                                    <el-option v-for="item in sys_settle_method" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="remarks" width="545" :label="$t('view.报价说明')">
                            <template  slot-scope="scope">
                                <vue-editor v-model="scope.row.remarks" class="my-custom-editor" style="width: 520px" :disabled="scope.row.isForceSettleMethod==1"></vue-editor>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="remarks1" width="150" :label="$t('view.备注')">
                          <template  slot-scope="scope">
                            <el-input class="BlueEditable" style="width:90%" type="textarea" resize='none' :placeholder="$t('view.请输入')"  :rows="1"  size="mini"  v-model="scope.row.remarks1" ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" prop="" :label="$t('view.附件')" width="150">
                            <template slot-scope="scope">
                                <el-upload  :action="uploadFile"
                                    :disabled="details.disabled"
                                    :headers="headers"
                                    :file-list="scope.row.fileList"
                                    :on-success="(res,file)=>{successList( scope.row.fileList,res,file)}"
                                    :on-remove="(res,file)=>{handleRemoveClear(scope.row,res)}"
                                    :ref="'upload'+scope.$index">
                                    <el-button v-if=" scope.row.fileList.length<1" size="mini" type="primary" @click.stop="fileUploadFile(scope.$index)">上传文件</el-button>
                                </el-upload>
                                
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="display:flex;margin: 15px 0;align-items: flex-end;flex-direction:row-reverse;">
                        <div v-if="bidSection.sectionStauts==1||bidSection.isAppointSupplierQuotationIng==1">
                            <el-button :disabled="isCurrentTimeInRange(this.bidSection.quotesStart , this.bidSection.quotesEnd)" v-loading.fullscreen.lock="fullscreenLoading" type="primary" @click="bidSection.isYuanJu==1?getYuanJuSystemQuotesPost(): systemQuotesPost()" style="width: 100px;margin-left: 20px;">{{ $t('view.提交') }}</el-button>
                        </div>
                        <div v-if="bidSection.sectionStauts==1||bidSection.isAppointSupplierQuotationIng==1">
                            <el-button :disabled="isCurrentTimeInRange(this.bidSection.quotesStart , this.bidSection.quotesEnd)" v-loading.fullscreen.lock="fullscreenLoading" type="primary" plain @click="save" style="width: 100px;background: rgba(64,158,255,0.1);border: 1px solid #409EFF;color: #409EFF;">{{$t('view.保存')}}</el-button>
                        </div>
                        <div style="margin-right:20px" v-if="bidSection.projectMaterialType!=35" >{{$t('view.整体总价')}}：
                            <span class="mainColor" style="font-size:24px;font-weight:600">{{getStatus('sys_currency',bidSection.currencyTypeId?bidSection.currencyTypeId:bidSection.currency,'remark')  }}{{ formatNum(quotationAmount) }}<span style="font-size:14px ;">{{ moneyUnit }}</span> </span>
                        </div>
                    </div>
                </div>
                <!-- 报价记录 -->
                <div class="box" v-if="HistoricalQuotation.length">
                    <div class="text">{{ $t('view.报价记录') }}</div>
                    <div v-for="(item,index) in HistoricalQuotation" :key="index">
                        <div class="Round">{{$t('view.第')}}{{arabicToChinese(item.quotesCount)  }}{{$t('view.轮报价')}}</div>
                        <div style="text-align: center;" @click="item.show=!item.show">{{item.show?$t('view.收起'):$t('view.展开') }}</div>
                        <el-table v-if="item.show&&bidSection.engineeringType!=2" border header-row-class-name="tableHeader" :data="item.quotesList" style="width: 100%">
                            <el-table-column fixed type="expand" v-if="bidSection.sectionType==1">
                                <template slot-scope="props">
                                    <el-table :data="props.row.details"  border header-row-class-name="tableHeader" style="width: 100%">
                                        <el-table-column align="center" show-overflow-tooltip type="index" width="60" :label="$t('view.序号')"/>
                                        <el-table-column align="center" show-overflow-tooltip prop="sectorName" :label="$t('view.物资名称')"></el-table-column>
                                        <el-table-column align="center" show-overflow-tooltip prop="remark" :label="$t('view.规格')">
                                            <template slot-scope="scope">
                                                {{ locale == 'en' ? scope.row.specificationsEn : locale == 'lo' ? scope.row.specificationsLo:scope.row.specifications}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column align="center" show-overflow-tooltip prop="remark" :label="$t('view.型号')">
                                            <template slot-scope="scope">
                                                {{ locale == 'en' ? scope.row.modelEn : locale == 'lo' ? scope.row.modelLo : scope.row.model }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column align="center" show-overflow-tooltip prop="sectorNumber" :label="$t('view.需求数量')"></el-table-column>
                                        <el-table-column align="center" show-overflow-tooltip prop="remark" :label="$t('view.计量单位')">
                                            <template slot-scope="scope">
                                                {{ locale == 'en' ? scope.row.detailUnitsEn : locale == 'lo' ? scope.row.detailUnitsLo:scope.row.detailUnits}}
                                            </template>
                                        </el-table-column>
                                        <!-- <el-table-column v-if="bidSection.budgetType==2" key="budgetAmount" align="center" show-overflow-tooltip prop="budgetAmount" :label="bidSection.sectorBudgetType==1? $t('view.预算总价'):$t('view.预算单价')">
                                            <template slot-scope="scope">
                                                {{scope.row.budgetAmount}}{{moneyUnit}}
                                            </template>
                                        </el-table-column> -->
                                    </el-table>
                                </template>
                            </el-table-column>
                            <el-table-column fixed align="center" type="index" width="60" :label="$t('view.序号')"/>
                            <el-table-column v-if="bidSection.sectionType!=1"  width="300" header-align="center"  :label="$t('view.标的物信息')">
                                <template slot-scope="scope">
                                    <div class="twoLine" style="max-height: 50px;"><span style="color: #9FA6AC;">{{$t('view.物料名称')}}：</span> {{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}</div>
                                    <div v-if="bidSection.budgetType==2&&bidSection.isYuanJu!=1">
                                        <span style="color: #9FA6AC;">{{ bidSection.sectorBudgetType==1? $t('view.预算总价'):$t('view.预算单价')}}：</span>
                                       {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{ formatNum(scope.row.budgetAmount )}}{{ moneyUnit }}
                                    </div>
                                    <div v-if="bidSection.isYuanJu==1"><span style="color: #9FA6AC;">{{$t('view.预算金额')}}：</span>
                                        {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{ formatNum(bidSection.biddingTradeType==1?scope.row.maxPrice :scope.row.minPrice )}}{{ moneyUnit }}
                                    </div>                                    
                                    <div><span style="color: #9FA6AC;">{{$t('view.需求数量')}}：</span> {{ scope.row.number }} / {{ scope.row.unit }}</div>
                                    <div><span style="color: #9FA6AC;">{{$t('view.规格')}}：</span> {{ locale == 'en' ? scope.row.specificationsEn : locale == 'lo' ? scope.row.specificationsLo:scope.row.specifications}}</div>
                                    <div><span style="color: #9FA6AC;">{{$t('view.型号')}}：</span> {{ locale == 'en' ? scope.row.modelEn : locale == 'lo' ? scope.row.modelLo : scope.row.model }}</div>
                                    <div class="single-line" :title="scope.row.sectorRemark" ><span style="color: #9FA6AC;">{{$t('view.其他')}}：</span>{{scope.row.sectorRemark?scope.row.sectorRemark:'-' }}</div>
                                    <div class="single-line" v-if="scope.row.outFileList&&scope.row.outFileList.length"><span style="color: #9FA6AC;">{{$t('view.是否含税')}}：<span @click="handleViewFile(scope.row.outFileList[0].filePath,scope.row.outFileList[0].fileName)" style="cursor: pointer;">{{scope.row.outFileList[0].fileName }}</span></span></div>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="bidSection.sectionType==1" align="center" fixed :label="$t('view.标段名称')" width="260" >
                                <template slot-scope="scope">
                                    <div>{{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column  v-if="bidSection.quotationMethod!=1" align="center" prop="quotesPrice" :label="(bidSection.isTax=='1'? $t('view.含税单价'):$t('view.单价'))+'('+moneyUnit+')'" width="150">
                                <template slot-scope="scope">
                                    <span>{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{formatNum(scope.row.quotesPrice)  }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="bidSection.isTax=='1'" align="center" prop="taxRate" :label="$t('view.税率')" width="150">
                                <template slot-scope="scope">
                                    <span>{{getStatus('sys_tax_rate',scope.row.taxRate)  }}</span>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column v-if="bidSection.quotationMethod!=1" align="center" prop="totalMaterialPrice" :label="$t('view.物料总价')+'('+moneyUnit+')'" width="150"></el-table-column> -->
                            <!-- <el-table-column v-if="bidSection.quotationMethod!=1&& bidSection.isYuanJu!=1" align="center" prop="otherExpenses" :label="$t('view.其他费用')+'('+moneyUnit+')'" width="120"></el-table-column> -->
                            <el-table-column  v-if="bidSection.projectMaterialType!=35" align="center" prop="totalPrice" :label="$t('view.总价')+'('+moneyUnit+')'"  width="120">
                                <template  slot-scope="scope">
                                    <span>{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{ formatNum(scope.row.totalPrice) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column  v-if="!(bidSection.sectionType != '1'&&bidSection.engineeringType!=2)||bidSection.successfulBidderMethod==1" align="center" prop="settleMethod" width="150" :label="$t('view.结算方式')">
                                <template slot-scope="scope">
                                    <span>{{getStatus('sys_settle_method',scope.row.settleMethod)  }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column   header-align="center" prop="remarks" width="540" :label="$t('view.报价说明')">
                                <template slot-scope="scope">
                                    <span v-html="scope.row.remarks"></span>
                                </template>
                            </el-table-column>
                            <el-table-column  align="center" prop="remarks1" width="150" :label="$t('view.备注')">
                            </el-table-column>
                            <!-- <el-table-column align="center" v-if="bidSection.sectionType!=1" prop="volume" :label="$t('view.单个体积')" width="150"></el-table-column>
                            <el-table-column align="center" v-if="bidSection.sectionType!=1" prop="unit" :label="$t('view.体积单位')" width="150">
                                <template slot-scope="scope">
                                    <span>{{getStatus('sys_volume_unit',scope.row.volumeUnit)  }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" v-if="bidSection.sectionType!=1" prop="weight" :label="$t('view.单个重量')" width="150"></el-table-column>
                            <el-table-column align="center" v-if="bidSection.sectionType!=1" prop="unit" :label="$t('view.重量单位')" width="150">
                                <template slot-scope="scope">
                                    <span>{{getStatus('sys_weight_unit',scope.row.weightUnit)  }}</span>
                                </template>
                            </el-table-column> -->
                            <!-- <el-table-column align="center" v-if="bidSection.showRanking&& bidSection.rankingType==0" prop="remarks" width="150" :label="$t('view.排名')">
                                <template  slot-scope="scope">
                                    <span class="mainColor">{{ scope.row.pricePank }}</span>
                                </template>
                            </el-table-column> -->
                            <!-- <el-table-column align="center" v-if="bidSection.supplierOffer==1" prop="remarks" width="150" :label="$t('view.本轮最低价')">
                                <template  slot-scope="scope">
                                    <span class="mainColor">{{ scope.row.minQuotesPrice  }}</span>
                                </template>
                            </el-table-column> -->
                            <!-- <el-table-column v-if="!(bidSection.sectionType != '1'&&bidSection.engineeringType!=2)" align="center" prop="fileList" width="150" :label="$t('view.附件')">
                                <template  slot-scope="scope">
                                    <div class="clickText" v-for="(item,index) in scope.row.fileList" :key="index">
                                        <span style="line-height: 20px;font-size: 14px;color:#409EFF" @click.stop="handleViewFile(item.filePath, item.fileName)">{{ item.fileName }}</span>
                                    </div>
                                </template>
                            </el-table-column> -->
                        </el-table>
                     
                        <el-form  v-show="item.show&&bidSection.sectionType != '1'&&bidSection.engineeringType!=2" disabled :model="item.quotesList[0]"  label-width="120px" style="margin-top:10px">
                            <el-form-item v-if="bidSection.successfulBidderMethod!=1" :label="$t('view.结算方式')" prop="settleMethod">
                                <span v-if="bidSection.settleMethod||item.quotesList[0].isForceSettleMethod==1">{{getStatus('sys_settle_method',item.quotesList[0].settleMethod)  }}</span>
                                <el-select class="BlueEditable" v-else size="mini" style="width: 300px" clearable v-model="item.quotesList[0].settleMethod">
                                    <el-option v-for="item1 in sys_settle_method" :key="item1.dictValue" :label="item1.dictLabel" :value="item1.dictValue"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('view.报价说明')" prop="declareName">
                                <vue-editor  v-model="item.quotesList[0].remarks" class="my-custom-editor BlueEditable" style="width: 520px" :disabled="true"></vue-editor>
                            </el-form-item>
                            <el-form-item :label="$t('view.备注')" prop="declareName" >
                                <el-input class="BlueEditable" type="textarea" :placeholder="$t('view.请输入')"  resize='none' :rows="3" size="mini" style="width: 520px;" v-model="item.quotesList[0].remarks1" ></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('view.附件')" prop="declareName">    
                                <div class="clickText" v-for="(item1,index) in item.quotesList[0].fileList" :key="index">
                                    <span style="line-height: 20px;font-size: 14px;color:#409EFF" @click.stop="handleViewFile(item1.filePath, item1.fileName)">{{ item1.fileName }}</span>
                                </div>
                            </el-form-item>
                        </el-form> 
                        
                        <!-- 总包 -->
                        <el-table v-if="bidSection.engineeringType==2&&item.show" max-height="500" border header-row-class-name="tableHeader" :data="item.quotesList" style="width: 100%;margin-top: 15px;">
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <el-table :data="props.row.details" border header-row-class-name="tableHeader" style="width: 100%">
                                        <el-table-column align="center"   :label="$t('view.物资名称')">
                                            <template slot-scope="scope">
                                                <div>{{ ++scope.$index }}、{{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}</div>
                                                <div>{{ $t('view.数量') }}：{{ scope.row.number }}{{ scope.row.detailUnits }}</div> 
                                                <div>{{$t('view.报价方式')}}：{{scope.row.quotationMethod==1?$t('view.总价'):$t('view.单价')}}（{{scope.row.moneyUnit}}/{{scope.row.detailUnits}}）</div>
                                                <div class="mainColor" v-if="scope.row.budgetAmount&&bidSection.budgetType==2">【{{$t('view.限价')}}：
                                                    {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}
                                                    {{formatNum(scope.row.budgetAmount)}}（{{scope.row.moneyUnit}}/{{scope.row.detailUnits}}）】</div>
                                            </template>
                                        </el-table-column>
                                        <!-- 煤炭的要显示 -->
                                        <el-table-column v-if="bidSection.projectMaterialType==35" align="center"  prop="priceType" key="priceType" width="150" :label="$t('view.价格类型')">
                                        </el-table-column>
                                        <el-table-column align="center" prop="detailPrice"  :label="bidSection.isTax=='1'?$t('view.报价（含税）'):$t('view.报价')">
                                             <template slot-scope="scope">
                                                <span>{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{formatNum(scope.row.detailPrice)  }}</span>
                                            </template>
                                        </el-table-column>
                                        <!-- 税率 -->
                                        <el-table-column align="center" v-if="bidSection.isTax=='1'" :label="$t('view.税率')">
                                            <template slot-scope="scope">
                                                <span>{{getStatus('sys_tax_rate',scope.row.taxRate)  }}</span>
                                            </template>
                                        </el-table-column>
                                        <!-- 系数 -->
                                        <el-table-column align="center"   :label="$t('view.系数')">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.coefficientName">
                                                    <span>{{ scope.row.coefficientName }}</span>
                                                    <div>{{ scope.row.coefficient }}</div>
                                                </div>
                                                <div v-else>/</div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column v-if="bidSection.projectMaterialType!=35" align="center"  :label="bidSection.isTax=='1'? $t('view.总价（含税）') :$t('view.总价')">
                                            <template slot-scope="scope">
                                                <span>{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}</span>
                                                <!-- 总价 -->
                                                <span v-if="scope.row.quotationMethod==1" >{{formatNum(scope.row.detailPrice?scope.row.detailPrice: 0 ) }}</span>
                                                <!-- 单价 -->
                                                <span v-else>{{formatNum(( scope.row.detailPrice* scope.row.number).toFixed(4))}}</span>
                                            </template> 
                                        </el-table-column>
                                    </el-table> 
                                </template>
                            </el-table-column>
                            <el-table-column  align="center" :label="$t('view.标段信息')">
                                <template slot-scope="scope">
                                    <div>{{ $t('view.标段') }} {{scope.row.sort}}：{{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}</div>
                                    <div  class="mainColor">（{{getStatus('sys_currency',scope.row.currencyTypeId)  }}/{{scope.row.moneyUnit}}）</div>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" width="150" prop="totalPrice" :label="bidSection.isTax=='1'? $t('view.总价（含税）') :$t('view.总价')">
                                <template  slot-scope="scope">
                                    <span class="mainColor">{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{ formatNum(scope.row.totalPrice) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center"  prop="remarks1" :label="$t('view.备注')">
                            </el-table-column>
                        </el-table>

                        <div v-if="bidSection.showRanking&& bidSection.rankingType==1" style="display:flex;margin: 15px 0;align-items: flex-end;flex-direction:row-reverse;">
                            <div>{{$t('view.整体总价')}}：
                                <span class="mainColor" style="font-size:24px;font-weight:600">{{getStatus('sys_currency',item.currency,'remark')  }}{{ formatNum(item.totalPrice) }}{{ moneyUnit }}</span>
                            </div>
                            <!-- <div style="margin-right:20px">{{ $t('view.整体排名') }}：
                                <span class="mainColor" style="font-size:24px;font-weight:600">{{ item.pricePank }}</span></div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>

  <script>
  import {systemQuotes,getQuotationInfo,systemQuotesPost,exportSectors,importFileSectors,selectendtime,sectionDetailExport,sectionDetailImport} from '@/api/PersonalCenter'
  import {getDicts} from '@/api/index'
  import { uploadFile } from '@/utils/request'
  import {arabicToChinese,timeCountDown} from '@/utils/sczn'
  import {money} from '@/utils/regular'
  import { VueEditor } from 'vue2-editor';
  import { getToken } from "@/utils/auth";
  export default {
    components: { VueEditor },
    data(){
      return{
        form:{fileList:[]},//普通类型的 这些东西拆出来
        timeCountDown,//倒计时
        moneyUnit:"",
        money,
        editorOptions: {
            // 其他配置项...
            modules: {
                toolbar: false // 隐藏工具栏
            }
        },
        bidSection:{},
        arabicToChinese,
        uploadFile,
        tableData:[],
        details:{},
        bidSectors:[],
        CbidSectors:[],//显示上一轮报价
        paymentTitle:[this.$t('view.预付款'),this.$t('view.发货款'),this.$t('view.到货款'),this.$t('view.到货检验款'),this.$t('view.设备安装费'),this.$t('view.项目检验费用'),this.$t('view.质保')],
        settleMethodsList:[],
        sys_section_type:[],
        sys_settle_method:[],//结算方式
        sys_volume_unit:[],//体积单位
        sys_weight_unit:[],//重量单位
        sys_bidding_method:[],//招标方式
        sys_tax_rate:[],//税率
        HistoricalQuotation:[],//历史报价
        sys_currency:[],//币种
        fullscreenLoading:false,
        locale: localStorage.getItem('locale')||'zh',
        headers: {
            Authorization:getToken()
        },
        timeList:'',
        timerId:'',
        bidSectors: [], // 原始大数据列表（假设已从接口获取）
        showBidSectors: [], // 用于展示的分批加载列表
        currentPage: 1, // 当前加载到第几页
        pageSize: 50, // 每页加载50条
        loadTimer: null, // 定时器标识，用于清除定时器
      }
    },
    computed:{
        quotationAmount() {
            let num =0
            if(this.bidSectors.length){
                // 总包
                if(this.bidSection.engineeringType==2){
                    this.bidSectors.map((item,index)=>{
                       this.getTotalPrice(item,index,false)
                    })
                    this.bidSectors.map(item=>{
                        num=num*1+item.totalPrice*item.unitConversion*1
                    })
                    
                }else{
                    this.bidSectors.map((item,index)=>{
                        // 报价方式总价
                        if( this.bidSection.quotationMethod==1){
                            let totalPrice=0
                            if(item.totalPrice){
                                // if(typeof item.totalPrice=='string'||typeof item.totalPrice=='String')
                                // item.totalPrice= item.totalPrice.replace(/[^\d.-]/g, '').match(/-?\d+(\.\d+)?/)?.[0] || ''
                                if(this.bidSection.isYuanJu==1){
                                    item.totalPrice=this.formatPriceByDigits(item.totalPrice,0) 
                                }else{
                                    item.totalPrice=this.formatPriceByDigits(item.totalPrice,this.bidSection.projectMaterialType==35? 0:8) 
                                }
                            }
                            totalPrice=item.totalPrice?item.totalPrice:(this.CbidSectors[index].totalPrice?this.CbidSectors[index].totalPrice:0)
                            num+=totalPrice*1
                        }else{
                            // if(item.otherExpenses){
                            //     item.otherExpenses= item.otherExpenses..replace(/[^\d.-]/g, '').match(/-?\d+(\.\d+)?/)?.[0] || '';
                            //     item.otherExpenses= item.otherExpenses.toString().match(/^\d+(?:\.\d{0,2})?/)[0];
                            // }
                            let sectorPrice=0
                            if(item.sectorPrice){
                                // 提取符合“-?数字.数字”或“-?数字”格式的内容（取第一个匹配项）
                                if(this.bidSection.isYuanJu==1){
                                    item.sectorPrice=this.formatPriceByDigits(item.sectorPrice,0) 
                                }else{
                                    item.sectorPrice= this.formatPriceByDigits(item.sectorPrice,this.bidSection.projectMaterialType==35? 0:8)
                                }
                            }
                            if(item.number){
                                item.number=this.formatPriceByDigits(item.number,6)
                            }else{
                                item.number = '1';
                            } 
                            sectorPrice=item.sectorPrice?item.sectorPrice:(this.CbidSectors[index].sectorPrice?this.CbidSectors[index].sectorPrice:0)
                            num+=item.otherExpenses*1+sectorPrice*item.number
                        }
                    })
                }

            }
            // this.bidSection.quotationMethod==1?4:2
            return  num.toFixed(4);
        }
    },
    beforeDestroy(){
        clearInterval(this.timerId);
         if (this.loadTimer) {
            clearInterval(this.loadTimer);
            this.loadTimer = null;
        }
    },
    created(){
         this.selectendtime()
         this.timerId=  setInterval(() => {
             this.selectendtime()
         }, 5000); // 5秒更新一次
        this.getDicts('sys_section_type')
        this.getDicts('sys_volume_unit')
        this.getDicts('sys_weight_unit')
        this.getDicts('sys_bidding_method')
        this.getDicts('sys_settle_method') //结算方式
        this.getDicts('sys_currency')
        this.getDicts('sys_tax_rate')
        this.$nextTick(function(){
           this.systemQuotes()
        })
      
    },
    methods:{
         // 是否在报价时间内
         isCurrentTimeInRange(startTimeStr, endTimeStr) {
            // 1. 获取当前时间（本地时间），提取时分秒
            const now = new Date();
            const nowHours = now.getHours();
            const nowMinutes = now.getMinutes();
            const nowSeconds = now.getSeconds();
            // 转换为当天的总秒数（便于比较）：小时*3600 + 分钟*60 + 秒
            const nowTotalSeconds = nowHours * 3600 + nowMinutes * 60 + nowSeconds;

            // 2. 解析时分秒字符串为总秒数的工具函数
            const parseTimeToSeconds = (timeStr) => {
                // 支持 "HH:MM:SS" 或 "HH:MM" 格式
                const parts = timeStr.split(':').map(Number);
                if (parts.length < 2 || parts.some(isNaN)) {
                    throw new Error(`时间格式无效：${timeStr}，请使用 HH:MM 或 HH:MM:SS`);
                }
                const hours = parts[0] || 0;
                const minutes = parts[1] || 0;
                const seconds = parts[2] || 0;
                
                // 校验时分秒的合法范围
                if (hours < 0 || hours > 23) throw new Error(`小时数不合法：${hours}`);
                if (minutes < 0 || minutes > 59) throw new Error(`分钟数不合法：${minutes}`);
                if (seconds < 0 || seconds > 59) throw new Error(`秒数不合法：${seconds}`);
                
                return hours * 3600 + minutes * 60 + seconds;
            };

            // 3. 解析开始时间
            let startTotalSeconds;
            try {
                startTotalSeconds = parseTimeToSeconds(startTimeStr);
            } catch (error) {
                console.error("解析开始时间失败：", error.message);
                return true;
            }

            // 4. 解析结束时间
            let endTotalSeconds;
            try {
                endTotalSeconds = parseTimeToSeconds(endTimeStr);
            } catch (error) {
                console.error("解析结束时间失败：", error.message);
                return true;
            }

            // 5. 处理跨天场景（比如 22:00 到 02:00）
            let isInRange;
            if (startTotalSeconds <= endTotalSeconds) {
                // 正常时间段（如 09:00-18:00）
                isInRange = nowTotalSeconds >= startTotalSeconds && nowTotalSeconds <= endTotalSeconds;
            } else {
                // 跨天时间段（如 22:00-02:00）
                isInRange = nowTotalSeconds >= startTotalSeconds || nowTotalSeconds <= endTotalSeconds;
            }

            // 保持原逻辑：返回 !isInRange（不在范围内返回true，在范围内返回false）
            return !isInRange;
        },
        formatPriceByDigits(value, decimalPlaces ) {
            value=value.toString()
            // 1. 过滤非允许字符（仅保留数字、负号、小数点）
            let filtered = value.replace(/[^\d.-]/g, '');

            // 2. 处理负号：仅允许开头出现一个负号
            const minusCount = (filtered.match(/-/g) || []).length;
            if (minusCount > 1) {
                // 保留第一个负号，移除其他负号
                const firstMinusIndex = filtered.indexOf('-');
                filtered = filtered.substring(0, firstMinusIndex + 1) + 
                        filtered.substring(firstMinusIndex + 1).replace(/-/g, '');
            }
            // 如果负号不在开头，移到开头
            if (filtered.includes('-') && !filtered.startsWith('-')) {
                filtered = '-' + filtered.replace(/-/g, '');
            }

            // 3. 处理小数点：仅允许一个小数点
            const dotCount = (filtered.match(/\./g) || []).length;
            if (dotCount > 1) {
                // 保留第一个小数点，移除其他小数点
                const firstDotIndex = filtered.indexOf('.');
                filtered = filtered.substring(0, firstDotIndex + 1) + 
                        filtered.substring(firstDotIndex + 1).replace(/\./g, '');
            }

            // 4. 限制小数位数（不自动补0）
            const dotIndex = filtered.indexOf('.');
            if (dotIndex !== -1) {
                const integerPart = filtered.substring(0, dotIndex);
                const decimalPart = filtered.substring(dotIndex + 1);
                // 截取指定长度的小数部分
                const limitedDecimal = decimalPart.substring(0, decimalPlaces);
                filtered = integerPart + '.' + limitedDecimal;
            }

            // 5. 特殊情况处理
            // 允许空值、纯负号、纯小数点、负号+小数点
            if (filtered === '' || filtered === '-' || filtered === '.' || filtered === '-.') {
                return filtered;
            }

            return filtered;
        },
        selectendtime(){
            selectendtime(this.$route.query.id).then(res=>{
                if(res.data.entTime){
                    this.timeCountDown(res.data.entTime,'',(value,clear)=>{
                        this.timeList=value
                        this.$once('hook:beforeDestroy', clear);
                    },)
                }
            })
        },
        // 保存
        save(){
            localStorage.setItem(this.$store.getters.userId+this.$route.query.id,JSON.stringify(this.bidSectors))
            this.$message.success(this.$t('view.保存成功'))
        },
        getYuanJuSystemQuotesPost() {
				// 整体中标的 第一轮都得填写 其他轮次只填写一个就行 
				let name = this.bidSection.quotationMethod == 1?'totalPrice':'sectorPrice'
				if(this.HistoricalQuotation.length==0){
					for(let i=0;i<this.bidSectors.length;i++){
						if(this.bidSection.successfulBidderMethod==2){
							if(!this.bidSectors[i][name]){
                                this.$message({  message:'请维护'+this.bidSectors[i].name+'标段价格',type: "warning",});
								return
							}
						}
					}
				}
	
				// 分项中标 至少有一个填写
				if(this.bidSection.successfulBidderMethod==1){
					let valList=[]
					this.bidSectors.map(item=>{
						if(item[name])
						valList.push(item[name])
					})
					if(!valList.length){
                        this.$message({  message:'至少维护一条数据',type: "warning",});
						
						return
					}
				}
				
				for (let i = 0; i < this.CbidSectors.length; i++) {
					if (this.bidSection.quotationMethod != 1) {
						
						// 最低价  biddingTradeType 1采购2销售 quotationMethod 单价总价
						if (this.bidSection.biddingTradeType == 1) {
							if (this.bidSectors[i].maxPrice&&this.bidSection.successfulBidderMethod==2&&this.bidSectors[i].sectorPrice&& this.bidSectors[i].sectorPrice > this.bidSectors[i].maxPrice) {
								
                                this.$message({  message:this.bidSectors[i].name + '报价不得大于' + this.bidSectors[i].maxPrice,type: "warning",});

								return
							}
						} else {
							if (this.bidSectors[i].sectorPrice&&this.bidSection.successfulBidderMethod==2&&this.bidSectors[i].minPrice&&  (this.bidSectors[i].sectorPrice < this.bidSectors[i].minPrice)) {
                                this.$message({  message:this.bidSectors[i].name + '报价不得小于' + this.bidSectors[i].minPrice,type: "warning",});

								return
							}
						}
					}
					// 最低价  biddingTradeType 1采购2销售 quotationMethod 单价总价
					
					if (this.bidSection.quotationMethod == 1) {
						if (this.bidSection.biddingTradeType == 1) { 
							if (this.bidSectors[i].totalPrice && this.bidSectors[i].maxPrice&&this.bidSection.successfulBidderMethod==2&&(this.bidSectors[i].totalPrice > this.bidSectors[i].maxPrice)) {
                                this.$message({  message:this.bidSectors[i].name + '报价不得大于预算（' + this.bidSectors[i].maxPrice +'）',type: "warning",});

								return
							}
						} else {
							if (this.bidSectors[i].totalPrice && this.bidSectors[i].minPrice&&this.bidSection.successfulBidderMethod==2&&(this.bidSectors[i].totalPrice < this.bidSectors[i].minPrice)) {
                                this.$message({  message:this.bidSectors[i].name + '报价不得小于预算（' + this.bidSectors[i].minPrice+'）',type: "warning",});

								return
							}
						}
					}
				}
				
				// let  a= []
				// this.CbidSectors.map((item,i)=>{
				// 	// 采购
				// 	if(this.bidSection.biddingTradeType==1){
				// 		if(item[name]&&this.bidSectors[i][name]&&(item[name]<this.bidSectors[i][name]))
				// 		a.push(item)
				// 	}else{
				// 		if(item[name]&&this.bidSectors[i][name]&&(item[name]>this.bidSectors[i][name]))
				// 		a.push(item)
				// 	}
				// })
				// if(a.length){
				// 	let tip =this.bidSection.biddingTradeType==1?'低于':'高于'
                //     this.$message({  message:'至少需要有一个标段'+ tip +'上次报价！',type: "warning",});
                //     return
				// }
				this.systemQuotesPost()
				
		},
        getTotalPrice(item,index,bol){
            // bol 是否需要赋值
            this.$set(item,'totalPrice',0)
            item.details.map((i,indexs)=>{
                if(bol){
                    if(i.detailPrice==this.CbidSectors[index].details[indexs].detailPrice){
                        i.isDefault=1
                    }
                    i.coefficient=i.coefficient?i.coefficient:this.CbidSectors[index].details[indexs].coefficient
                    if(i.detailPrice) 
                    i.detailPrice=(i.detailPrice+'').replace(/[^\d.-]/g, '').match(/-?\d+(\.\d+)?/)?.[0] || ''
                    i.detailPrice=i.detailPrice?i.detailPrice:this.CbidSectors[index].details[indexs].detailPrice
                }
                if(i.detailPrice){
                    // i.detailPrice=(i.detailPrice+'').replace(/[^\d.-]/g, '').match(/-?\d+(\.\d+)?/)?.[0] || ''
                    i.detailPrice=this.bidSection.isYuanJu==1? this.formatPriceByDigits(i.detailPrice,0) :this.formatPriceByDigits(i.detailPrice,this.bidSection.projectMaterialType==35? 0:8) 
                }
                let detailPrice= i.detailPrice? i.detailPrice:this.CbidSectors[index].details[indexs].detailPrice
                // unitConversion 转换比例
                let basePrice = i.quotationMethod == 1 ? (detailPrice || 0)  : this.multiply(detailPrice, i.number);
                let price = this.multiply(basePrice, i.unitConversionSector);

                item.totalPrice=price*1+item.totalPrice*1
            })
            // 这俩值没用 后台要
            if(item.totalPrice)
            item.totalPrice=item.totalPrice.toFixed(4)
            this.$set(item,'totalPrice',item.totalPrice)
            this.$set(item,'sectorPrice',item.totalPrice) 
        },
        multiply(num1, num2){
            console.log('123',num1, num2)
            let m = 0;
            const s1 = num1.toString();
            const s2 = num2.toString();
            try { m += s1.split('.')[1].length; } catch (e) {}
            try { m += s2.split('.')[1].length; } catch (e) {}
            return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
        },
        systemQuotesPost(){
            // let list =[ {key:'taxRate',name:this.$t('view.税率')},
            //         {key:'sectorPrice',name:this.$t('view.单价')},
            //         // {key:'otherExpenses',name:this.$t('view.其他费用')},
            //         //{key:'remarks',name:this.$t('view.报价说明')}
            //         ]
            // for(let i=0;i<this.bidSectors.length;i++){
            //     for(let y=0;y<list.length;y++){
            //         if(this.bidSectors[i][list[y].key]==''||!this.bidSectors[i][list[y].key]){
            //             this.$parent.$refs.PopUpPrompt.open(this.$t('view.请完善')+list[y].name+this.$t('view.信息'))
            //             return
            //         }
            //     }
            // }
           
            // 整体中标 如果本次没填 把上一次的记录带上 
            // 不区分整体还是分项了 都带上
            let data =JSON.parse(JSON.stringify(this.bidSectors))
            // if(this.bidSection.successfulBidderMethod==2){
                
            if(this.bidSection.engineeringType==2){
                for(let i=0;i<data.length;i++){
                    this.getTotalPrice(data[i],i,true)
                }
                
            }else{
                data.map((item,index)=>{
                    if(this.bidSection.quotationMethod!=1&&(item.sectorPrice==this.CbidSectors[index].sectorPrice)){
                        item.isDefault=1
                    }
                    if(item.sectorPrice||this.CbidSectors[index].sectorPrice)
                    item.sectorPrice=item.sectorPrice?item.sectorPrice:this.CbidSectors[index].sectorPrice
                    if(this.bidSection.quotationMethod==1&&(item.totalPrice==this.CbidSectors[index].totalPrice)){
                        item.isDefault=1
                    }
                    if(item.totalPrice||this.CbidSectors[index].totalPrice)
                    item.totalPrice=item.totalPrice?item.totalPrice:this.CbidSectors[index].totalPrice
                })
            }
            
            // }
            // 1 总价 0 单价
            if(this.bidSection.quotationMethod==1){
                data.map(item=>{
                    item.unit=item.sectorUnits
                    item.costCoefficientTotalPrice= item.totalPrice*item.costCoefficient
                    item.sectorPrice =(item.totalPrice/item.number).toFixed(4)
                    item.totalMaterialPrice=item.totalPrice
                })
            }else{
                data.map(item=>{
                    item.totalMaterialPrice=item.sectorPrice*item.number
                    item.unit=item.sectorUnits
                    item.totalPrice= parseFloat((item.otherExpenses * 1 + item.totalMaterialPrice * 1).toFixed(4));
                    item.costCoefficientTotalPrice= item.totalPrice*item.costCoefficient
                })
            }
            // 总包的情况 如果有报价那 系数如果有值就得必填
            if(this.bidSection.engineeringType==2){
                for(let i=0;i<data.length;i++){
                    for(let y=0;y<data[i].details.length;y++){
                        if(data[i].details[y].detailPrice&&data[i].details[y].coefficientName&&!data[i].details[y].coefficient){
                            this.$message({  message:'请输入'+data[i].details[y].coefficientName,type: "warning"});
                            return
                        }
                    }
                }
            }
            let name = this.bidSection.quotationMethod == 1?'totalPrice':'sectorPrice'
            let nameList=[]
            for(let i=0;i<data.length;i++){
                // 总包
                if(this.bidSection.engineeringType==2){
                    for(let y=0;y<data[i].details.length;y++){
                        if((data[i].details[y].detailPrice==0||data[i].details[y].detailPrice==0.000)&&data[i].details[y].detailPrice){
                            let obj=data[i].details[y]
                            nameList.push(this.locale=='en'?obj.sectorNameEn:this.locale=='lo'?obj.sectorNameLo:obj.sectorName)
                        }
                    }
                }else{
                    if((data[i][name]==0||data[i][name]==0.000)&&data[i][name]){
                        let obj=data[i] 
                        if(this.bidSection.sectionType==1){
                            nameList.push(this.locale=='en'?obj.nameEn:this.locale=='lo'?obj.nameLo:obj.name)
                        }else{
                            nameList.push(this.locale=='en'?obj.sectorNameEn:this.locale=='lo'?obj.sectorNameLo:obj.sectorName)
                        }
                    }
                }
            }
            if(this.bidSection.sectionType != '1'&&this.bidSection.engineeringType!=2 ){
                data.map(item=>{
                    if(this.form.remarks)
                    item.remarks=this.form.remarks
                    item.isForceSettleMethod=this.form.isForceSettleMethod
                    if(this.form.remarks1)
                    item.remarks1=this.form.remarks1
                    item.fileList=this.form.fileList
                    if(this.bidSection.successfulBidderMethod!=1)
                    item.settleMethod=this.form.settleMethod
                })
            }
            if(this.isCurrentTimeInRange(this.bidSection.quotesStart , this.bidSection.quotesEnd)){
                return
            }
            if(nameList.length){
                let that = this;
                this.$confirm(that.$t('view.请确认')+'('+nameList.join("、")+")"+that.$t('view.真实报价是否为0，若不对该标的物进行报价，则空置不填'), that.$t('view.提示'), {
                    confirmButtonText:that.$t('view.确定'),
                    cancelButtonText: that.$t('view.取消'),
                    type: 'warning'
                }).then(() => {
                    this.fullscreenLoading = true;
                    systemQuotesPost({bidQuotes:data} ).then(res=>{
                        this.fullscreenLoading = false;
                        if(res.code==200){
                            this.$parent.$refs.PopUpPrompt.open(this.$t('view.操作成功'))
                            // this.$message.success()
                            localStorage.removeItem(this.$store.getters.userId+this.$route.query.id)

                            setTimeout(function() {
                            location.reload()
                            }, 3000);
                        }
                    })
                })
            }else{
                this.fullscreenLoading = true;
                systemQuotesPost({bidQuotes:data} ).then(res=>{
                    this.fullscreenLoading = false;
                    if(res.code==200){
                        this.$parent.$refs.PopUpPrompt.open(this.$t('view.操作成功'))
                        // this.$message.success()
                        localStorage.removeItem(this.$store.getters.userId+this.$route.query.id)

                        setTimeout(function() {
                        location.reload()
                        }, 3000);
                    }
                })
            }
                         
           
        },
        // 查询历史记录
        getQuotationInfo(){
            getQuotationInfo(this.bidSection.sectionId).then(res=>{
                res.data.map(item=>{
                    this.$set(item,'show',false)
                })
                this.HistoricalQuotation=res.data
                // res.data.map(item=>{
                //     if(!this.HistoricalQuotation[item.quotesCount-1])
                //     this.HistoricalQuotation[item.quotesCount-1]=[]
                //     this.HistoricalQuotation[item.quotesCount-1].push(item)
                // })
                // this.HistoricalQuotation.map(item=>item.reverse())
                // // 倒叙
                this.HistoricalQuotation.reverse()
                // 用来显示上一轮报价的


            })
        },
        getDicts(type){
            getDicts(type).then(res=>{
                res.data.map(item=>{
                    item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
                })
                this[type]=res.data
            })
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            // 如果不是最后一行，不处理
            if (rowIndex !== this.tableData.length - 1) {
                return { rowspan: 1, colspan: 1 };
            }

            // 检查最后一行右边内容是否为空
            const lastRow = this.tableData[this.tableData.length - 1];
            const isRightEmpty = !lastRow.RightValue || lastRow.RightValue.trim() === '';

            // 如果右边内容为空，则合并
            if (isRightEmpty) {
                if (columnIndex === 0) { // LeftTitle列：保持不变
                    return { rowspan: 1, colspan: 1 };
                } else if (columnIndex === 1) { // LeftValue列：向右合并3列（覆盖RightTitle和RightValue）
                    return { rowspan: 1, colspan: 3 };
                } else if (columnIndex === 2 || columnIndex === 3) { // RightTitle和RightValue列：隐藏
                    return { rowspan: 0, colspan: 0 };
                }
            }

            // 默认情况：不合并
            return { rowspan: 1, colspan: 1 };
        },
        //数据列表
        systemQuotes(){
            systemQuotes(this.$route.query.id).then(res=>{
                this.details=res.data
                this.bidSection=res.data.bidSection
                this.settleMethodsList = res.data.bidSection.settleMethodsList;
                res.data.bidSectors.map(item=>{
                    if(item.minOrMaxQuotesAmount!=null)
					item.minOrMaxQuotesAmount+=''
                    if(!item.taxRate&&this.bidSection.isTax=='1')item.taxRate='13'
                    if(!item.settleMethod){
                      item.settleMethod=this.bidSection.settleMethod
                    }
                    if(item.fileList == null || item.fileList.length == 0){
                        item.fileList = [];
                    }else{
                        item.fileList[0].name = item.fileList[0].fileName;
                    }
                    if (item.sectorPrice)
					item.sectorPrice = parseFloat(item.sectorPrice).toString()*1;
                    if (item.totalPrice)
                    item.totalPrice = parseFloat(item.totalPrice).toString()*1;
                })
                this.moneyUnit = (this.locale=='en'?this.bidSection.moneyUnitEn:this.locale=='lo'?this.bidSection.moneyUnitLo:this.bidSection.moneyUnit);
                // 总包
                if(this.bidSection.engineeringType==2){
                    this.bidSectors.map(item=>{
                        item.details.map(i=>{
                            if(!i.taxRate)i.taxRate='13'
                        })
                    })
                }
                let data=this.bidSection
                let sceneAddress=''
                if(data.sceneAddressEn||data.sceneAddressLo||data.sceneAddress){
                    sceneAddress=  this.locale=='en'?data.sceneAddressEn:this.locale=='lo'?data.sceneAddressLo:this.locale='zh'?data.sceneAddress:''
                }
                // 询价
                if(this.bidSection.biddingType==1){
                    this.tableData=[
                        {LeftTitle:this.$t('view.询价单位'),LeftValue:data.organization,
                        RightTitle:this.$t('view.项目类型'),RightValue:this.getStatus('sys_section_type',data.projectType) },
                        {LeftTitle:this.$t('view.中标方式') ,LeftValue:data.successfulBidderMethod==1?this.$t('view.分项'):this.$t('view.整体'),
                        RightTitle:this.$t('view.报价方式'),RightValue:data.quotationMethod==0?this.$t('view.单价'):this.$t('view.总价')},
                        {LeftTitle:this.$t('view.是否公开询价'),LeftValue:data.biddingMethod==1?this.$t('view.是'):this.$t('view.否'),
                        RightTitle:this.$t('view.是否含税'),RightValue:data.isTax==1?this.$t('view.是'):this.$t('view.否')},
                        {LeftTitle:this.$t('view.币种'),LeftValue:this.getStatus('sys_currency',data.currency),
                        RightTitle:this.$t('view.结算方式'),RightValue:data.settleMethod==='0'?this.$t('view.先款后货'):data.settleMethod==1?this.$t('view.先货后款'):data.settleMethod==2?this.$t('view.按比例支付'):''},
                        {LeftTitle:this.$t('view.询价截止时间'),LeftValue:data.entTime,  
                        RightTitle:this.$t('view.期望到货日期'),RightValue:data.expectedDeliveryDate},
                        {LeftTitle:this.$t('view.联系人'),LeftValue:data.businessContacts,  
                        RightTitle:this.$t('view.联系电话'),RightValue:data.businessPhoneNumber}]
                }else{
                    this.tableData=[{LeftTitle:this.$t('view.招标单位'),LeftValue:data.organization,RightTitle:this.$t('view.项目类型'),RightValue:this.getStatus('sys_section_type',data.projectType) },
                        {LeftTitle:this.$t('view.招标方式'),LeftValue:this.getStatus('sys_bidding_method',data.biddingMethod) ,RightTitle:this.$t('view.投标方式'),RightValue:data.isSceneBidding==1?('('+this.$t('view.现场招标')+')'+(sceneAddress)):this.$t('view.线上招标')},
                        {LeftTitle:this.$t('view.中标方式'),LeftValue:data.successfulBidderMethod==1?this.$t('view.分项'):this.$t('view.整体'),RightTitle:this.$t('view.是否提交投标文件'),RightValue:this.$t('view.是否提交投标文件')},
                        {LeftTitle:this.$t('view.商务联系人/电话'),LeftValue:data.businessContacts+'/'+data.businessPhoneNumber,RightTitle:this.$t('view.技术联系人/电话'),RightValue:data.technicalContacts+'/'+data.technicalPhoneNumber},
                        {LeftTitle:this.$t('view.质保期'),LeftValue:data.warranty,RightTitle:this.$t('view.是否含税'),RightValue:this.bidSection.isTax=='1'?this.$t('view.是'):this.$t('view.否')},
                        {LeftTitle:this.$t('view.币种'),LeftValue:this.getStatus('sys_currency',this.bidSection.currency),RightTitle:this.$t('view.开标时间'),RightValue:data.startTime},]
                        if(this.bidSection.isYuanJu==1){
                        this.tableData=[
                            {LeftTitle:this.$t('view.招标单位'),LeftValue:data.organization,RightTitle:this.$t('view.项目类型'),RightValue:this.getStatus('sys_section_type',data.projectType) },
                            {LeftTitle:this.$t('view.招标方式'),LeftValue:this.getStatus('sys_bidding_method',data.biddingMethod) ,RightTitle:this.$t('view.投标方式'),RightValue:data.isSceneBidding==1?('('+this.$t('view.现场招标')+')'+(sceneAddress)):this.$t('view.线上招标')},
                            {LeftTitle:this.$t('view.中标方式'),LeftValue:data.successfulBidderMethod==1?this.$t('view.分项'):this.$t('view.整体'),RightTitle:this.$t('view.是否提交投标文件'),RightValue:this.$t('view.是否提交投标文件')},
                            {LeftTitle:this.$t('view.商务联系人/电话'),LeftValue:data.businessContacts+'/'+data.businessPhoneNumber,RightTitle:this.$t('view.质保期'),RightValue:data.warranty},
                            {LeftTitle:this.$t('view.开标时间'),LeftValue:data.startTime,RightTitle:this.$t('view.报名时间'),RightValue:!data.signupStartTime?'':(data.signupStartTime+'-'+data.signupEndTime)},
                            ]
                    }
                }
                if ( data.isEntrustedBid === 1 &&this.tableData.length > 0) { 
                    // 保存原始表格数据用于处理移位
                    const originalTable = [...this.tableData];
                    // 新表格数组，先放入委托投标项
                    const newTable = [{
                        // 原第一项的Left内容保持在左侧
                        LeftTitle: originalTable[0].LeftTitle,
                        LeftValue: originalTable[0].LeftValue,
                        // 将委托投标信息放到右侧
                        RightTitle: this.$t('view.建设单位'),
                        RightValue: data.constructionOrganizationName
                    }];
                    
                    // 处理后续项的移位逻辑
                    for (let i = 0; i < originalTable.length; i++) {
                        // 当前项存在右内容时才需要处理移位
                        if (originalTable[i].RightTitle) {
                            newTable.push({
                                LeftTitle: originalTable[i].RightTitle,
                                LeftValue: originalTable[i].RightValue,
                                // 如果有下一项，使用下一项的Left作为当前项的Right
                                RightTitle: originalTable[i + 1]?.LeftTitle || '',
                                RightValue: originalTable[i + 1]?.LeftValue || ''
                            });
                        }
                    }
                    
                    // 使用处理后的新表格
                    this.tableData = newTable;
                }
                if(this.bidSection.settleMethod==2){
                    this.paymentTitle=[
                        {name:this.$t('view.预付款'),value:this.bidSection.advancePaymentRatio},
                        {name:this.$t('view.发货款'),value:this.bidSection.paymentShipmentRatio},
                        {name:this.$t('view.到货款'),value:this.bidSection.deliveryPaymentRatio},
                        {name:this.$t('view.到货检验款'),value:this.bidSection.arrivalAcceptancePaymentRatio},
                        {name:this.$t('view.设备安装费'),value:this.bidSection.equipmentInstallationPaymentRatio},
                        {name:this.$t('view.项目检验费用'),value:this.bidSection.projectAcceptancePaymentRatio},
                        {name:this.$t('view.质保'),value:this.bidSection.warrantyPaymentRatio}]
                }
                this.getQuotationInfo()
                this.CbidSectors = JSON.parse(JSON.stringify(res.data.bidSectors))
                // this.bidSectors.map(item=>{
                //     item.sectorPrice=''
                //     item.totalPrice=''
                //     item.details.map(i=>{
                //         i.detailPrice=''
                //     })
                // })
                
                this.showBidSectors= localStorage.getItem(this.$store.getters.userId+this.$route.query.id)? JSON.parse(localStorage.getItem(this.$store.getters.userId+this.$route.query.id)) : res.data.bidSectors
                // this.loadBatchData()
                this.startLoadTimer()
                this.CbidSectors.map(item=>{
                    item.sectorPrice=(item.sectorPrice||item.sectorPrice==0)?item.sectorPrice:''
                    item.totalPrice=(item.totalPrice||item.totalPrice==0)?item.totalPrice:''
                    item.details.map(i=>{
                        i.detailPrice=(i.detailPrice||i.detailPrice==0)?i.detailPrice:''
                    })
                })
                // 如果是普通版的报价 需要将备注 报价说明 附件拆出来
                // if(this.bidSection.sectionType != '1'&&this.bidSection.engineeringType!=2 ){
                //     this.form={
                //         remarks:this.bidSectors[0].remarks,
                //         isForceSettleMethod:this.bidSectors[0].isForceSettleMethod,
                //         remarks1: this.bidSectors[0].remarks1,
                //         fileList:this.bidSectors[0].fileList,
                //         isForceSettleMethod: this.bidSectors[0].isForceSettleMethod,
                //         settleMethod:this.bidSectors[0].settleMethod,
                //     } 
                // }
                })
        },
         // 加载指定批次的数据
        loadBatchData() { 
            // 计算当前批次的起始和结束索引
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = this.currentPage * this.pageSize;
            // 截取当前批次的数据
            const batchData = this.showBidSectors.slice(startIndex, endIndex);
            // 追加到展示列表中
            this.bidSectors = [...this.bidSectors, ...batchData];
            // 如果当前批次已经是最后一批，清除定时器
            if (endIndex >= this.showBidSectors.length) {
                if (this.loadTimer) {
                clearInterval(this.loadTimer);
                this.loadTimer = null;
                }
                return;
            }
            // 页码+1，准备下一批加载
            this.currentPage++;
        },
        // 启动定时器，每隔2秒加载一批数据
        startLoadTimer() {
            this.loadTimer = setInterval(() => {
                this.loadBatchData();
            }, 2000); // 2秒加载一次
        },
        //表格样式
        rowClass(row, column, rowIndex, columnIndex){
            if(row.column.property=='LeftTitle'||row.column.property=='RightTitle'){
                return "background: #F2F6FC;color: #626783;"
            }
        },

        //资质上传
        fileUploadFile(index){
            this.$refs['upload'+index].$refs["upload-inner"].handleClick();
        },

        successList(list,res,file){
            if(!list){
                list=[]
            }
            list.push({
                name:file.response.originalFilename,
                fileName:file.response.originalFilename,
                filePath:file.response.fileName,
                url: file.response.url,
                type:file.response.originalFilename.split(".").pop(),
                fileSize:file.size
            })
        },
        handleRemoveClear(list,res){
            this.$set(list,'fileList',[])
        },
         // 附件查看与下载
        handleViewFile(filePath, fileName) {
            const ext = filePath.substr(filePath.lastIndexOf('.') + 1, filePath.length)
            if (ext == 'pdf' || 'PDF') {
                window.open(filePath, "_blank");
            } else {
                const eLink = document.createElement("a");
                eLink.download = fileName;
                eLink.style.display = "none";
                eLink.href = filePath;
                document.body.appendChild(eLink);
                eLink.click();
                eLink.remove()
            }
        },
         handleExport() {
            if(this.bidSection.engineeringType==2){
                sectionDetailExport(this.$route.query.id,this.$t('view.报价模板'))
            }else{
                exportSectors(this.$route.query.id,this.$t('view.报价模板'))
            }
        },
        importFile(param) {
            const formData = new FormData();
            formData.append("file", param.file);
            const loading = this.$loading({
            lock: true,
            text: this.$t('view.导入中'),
            spinner: 'el-icon-loading',
            });
            let api = this.bidSection.engineeringType==2?sectionDetailImport:importFileSectors
            api(this.$route.query.id,formData).then((response) => {
                if (response.code == 200) {
                    this.bidSectors=response.data;
                    this.$modal.msgSuccess(this.$t('view.导入成功'));
                    loading.close();

                } else {
                    this.$message({  message: this.$t('view.操作失败'),type: "warning",});
                    loading.close();
                }

            }).catch((err)=>{
                loading.close();
            });
        },
    }
  };
  </script>
  <style lang="scss" scoped>
    .title{
        margin: 20px 0;
        line-height: 60px;
        font-size: 24px;
        font-weight: 600;
        color: #333333;
        text-align: center;
        border-bottom: solid 2px $Border-color;
    }
    .title1{
        font-size: 30px;
        font-weight: 700;
        color: $mainBody-color;
        text-align: center;
        padding-bottom: 10px;
        border-bottom: solid 2px $Border-color;
    }
    .box{
        padding: 10px 0;
    }
    .text{
        font-size: 24px;
        font-weight: 600;
        color: #000928;
    }
    .Round{
        font-size: 20px;
        font-weight: 600;
        text-align: center;
        color: #303133;
        margin: 10px 0 20px 0;
    }
    .border{
        border: solid 1px $Border-color;
        padding: 20px;
        width: 1160px;
        background: #fff;
        margin-bottom: 20px;
    }
  </style>
<style>
    .ql-editor{
        font-size: 13px !important;
        min-height: 100px !important;
    }
</style>
<style>
.BlueEditable .el-input__inner{border-color: #409EFF;}
.BlueEditable .el-textarea__inner{border-color: #409EFF;}
/* 使用自定义类名来定位并隐藏工具栏 */
.my-custom-editor .ql-toolbar {
  display: none; /* 隐藏工具栏 */
}
.my-custom-editor .ql-container.ql-snow{
   border-top: #409EFF solid 1px !important;
   border-color: #409EFF !important;

}
</style>
